export default "__VITE_ASSET__ChLFn2hq__"